import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAccessToken } from '../useProfile';

type DeleteWorkoutVariables = {
  workoutId: number;
};

export const useDeleteWorkout = () => {
  const { data: accessToken } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ workoutId }: DeleteWorkoutVariables) => {
      const response = await fetch(
        `${import.meta.env.REACT_APP_API_SERVICE_URI}/api/profile/workouts/${workoutId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({ id: workoutId }),
        },
      );

      if (!response.ok) {
        throw new Error('Unable to delete this activity.');
      }

      return response.text();
    },
    onSuccess: async (_data, { workoutId }) => {
      queryClient.removeQueries({ queryKey: ['workout', String(workoutId)] });
      await queryClient.invalidateQueries({ queryKey: ['workouts'] });
    },
  });
};
